import { Box } from "@mui/joy";
import { theme } from "../../styles/theme";
import FullPageContainer from "../container/FullPageContainer";
import SimpleMdToTypo from "../../components/common/SimpleMdToTypo";

// 디스턴싱 앰버서더 전용 페이지 가입 약관 — 디스턴싱 서비스 이용약관과 별개.
// 규율 범위는 전용 페이지 가입·이용과 개인정보 처리까지다. 실제 앰버서더 활동·수수료 조건은
// 가입 이후 회사와 개별 체결하는 별도 계약이 정하며, 본 약관과 충돌 시 별도 계약이 우선한다.
const AMBASSADOR_TERMS_MD = `
# 디스턴싱 **앰버서더 이용약관**

### **제1조 (목적)**

1. 본 약관은 주식회사 오웰헬스(이하 "회사")가 운영하는 디스턴싱 앰버서더 전용 페이지(이하 "전용 페이지")의 가입 및 이용 조건과 그 과정에서의 개인정보 처리에 관한 기본적인 사항을 규정함을 목적으로 합니다.

2. 전용 페이지는 디지털 심리치료 프로그램 "디스턴싱" 서비스와는 별개의 서비스이며, 디스턴싱 서비스 이용약관은 본 약관에 적용되지 않습니다.

3. 앰버서더 활동(홍보 활동, 수수료 지급 등)의 구체적인 조건은 가입 이후 회사와 앰버서더가 별도로 체결하는 계약(이하 "앰버서더 계약")으로 정합니다. 본 약관과 앰버서더 계약의 내용이 다른 경우 앰버서더 계약이 우선합니다.

### **제2조 (용어의 정의)**

1. "앰버서더"라 함은 본 약관에 동의하고 전용 페이지에 가입한 후, 회사와 앰버서더 계약을 체결하여 디스턴싱을 홍보하는 자를 의미합니다.

2. "추천 링크(코드)"라 함은 앰버서더별로 부여되는 고유 URL 또는 코드로, 이를 통한 가입·결제 성과를 식별하는 수단을 의미합니다.

3. "성과"라 함은 추천 링크를 통해 디스턴싱에 가입하거나 결제한 이용자 수 등 회사가 집계하는 지표를 의미합니다.

### **제3조 (가입 및 계정 관리)**

1. 전용 페이지 가입은 본 약관에 동의한 후 휴대전화번호 인증을 완료함으로써 이루어집니다.

2. 전용 페이지 가입은 앰버서더 계약의 체결이 아니며, 가입만으로 앰버서더 활동의 개시나 수수료 지급 청구권이 발생하지 않습니다.

3. 가입자는 가입 및 이용 과정에서 정확한 정보를 제공해야 하며, 허위 정보 제공으로 발생하는 불이익에 대해 회사는 책임지지 않습니다.

4. 계정과 비밀번호의 관리 책임은 가입자 본인에게 있으며, 제3자에게 계정을 양도하거나 대여할 수 없습니다.

### **제4조 (전용 페이지의 기능)**

1. 회사는 전용 페이지를 통해 다음 기능을 제공합니다.

1) 계약 정보(정산에 필요한 실명 또는 사업자 정보, 연락처, 통장 사본 등)의 제출

2) 추천 링크(코드)의 신청 및 관리

3) 추천 링크를 통한 성과와 정산 예정 금액의 조회

2. 추천 링크(코드)의 활성화는 회사의 확인·승인 후 이루어지며, 회사는 부정 가입 또는 어뷰징이 의심되는 경우 승인을 거부하거나 활성화를 중단할 수 있습니다.

3. 전용 페이지에 표시되는 성과와 정산 예정 금액은 참고용 집계이며, 확정 정산 금액과 지급 조건은 앰버서더 계약 및 정산 절차에 따릅니다.

### **제5조 (금지행위)**

가입자는 다음 각 호의 행위를 해서는 안 되며, 위반 시 회사는 계정 이용을 제한하거나 계약을 해지할 수 있습니다.

1. 타인의 전화번호 또는 정보를 도용한 가입

2. 본인 또는 가족 명의의 가입·결제를 유도하는 등 성과를 부정하게 만드는 행위(셀프 레퍼럴)

3. 전용 페이지의 정상적인 운영을 방해하는 행위

4. 기타 관계 법령에 위반되거나 회사의 명예를 훼손하는 행위

### **제6조 (개인정보의 수집 및 이용)**

① 회사는 전용 페이지 운영을 위해 다음과 같이 개인정보를 수집·이용합니다.

| 구분 | 수집 항목 | 수집·이용 목적 | 보유·이용 기간 |
| --- | --- | --- | --- |
| 필수 (가입 시) | 휴대전화번호, 비밀번호 | 가입 의사 확인, 본인 확인(알림톡 인증), 계정 관리 | 탈퇴 시까지 |
| 선택 (계약 정보 제출 시) | 실명 또는 사업자명, 사업자등록증, 이메일, 연락처, 활동명, 통장 사본 | 앰버서더 계약 체결, 수수료 정산 및 지급, 세무 처리 | 탈퇴 또는 계약 종료 시까지 (관계 법령상 보존 의무가 있는 경우 해당 기간) |

② 관계 법령에 따라 보존이 필요한 정보는 다음 기간 동안 보관 후 파기합니다.

- 계약 또는 청약철회 등에 관한 기록, 대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)

- 세법상 거래 관련 장부 및 증빙: 5년 (국세기본법)

③ 회사는 원활한 업무 처리를 위하여 다음과 같이 개인정보 처리를 위탁하고 있습니다.

| 위탁받는 자(수탁자) | 위탁하는 업무의 내용 |
| --- | --- |
| 엔에이치엔클라우드 주식회사 | 카카오 알림톡(인증번호) 발송 |
| Amazon Web Services Inc. | 클라우드 서버 운영 및 관리 |

④ 귀하는 개인정보 수집·이용에 동의하지 않을 권리가 있습니다. 다만, 필수 항목의 수집·이용에 동의하지 않는 경우 전용 페이지 가입이 불가능하며, 계약 정보를 제출하지 않는 경우 앰버서더 계약 체결과 수수료 정산이 불가능합니다.

⑤ 개인정보 관련 문의: privacy@orwellhealth.org

### **제7조 (탈퇴 및 이용 제한)**

1. 가입자는 언제든지 회사에 탈퇴를 요청하여 전용 페이지 이용을 종료할 수 있습니다. 앰버서더 계약이 체결되어 있는 경우 계약의 종료·정산은 해당 계약에 따릅니다.

2. 회사는 가입자가 본 약관을 위반한 경우 시정을 요구할 수 있으며, 시정되지 않거나 위반이 중대한 경우 계정 이용을 제한하거나 계약을 해지하고 추천 링크(코드)를 비활성화할 수 있습니다.

3. 회사는 운영상 필요한 경우 30일 전 통지 후 전용 페이지 제공을 변경하거나 종료할 수 있습니다.

### **제8조 (약관의 변경)**

1. 회사는 관계 법령을 위배하지 않는 범위에서 본 약관을 변경할 수 있으며, 변경 시 적용일자 및 변경 사유를 명시하여 적용일자 7일 전부터 공지합니다. 다만, 가입자에게 불리한 변경의 경우 30일 전부터 공지합니다.

2. 가입자가 변경 약관의 적용일까지 거부 의사를 표시하지 않으면 변경에 동의한 것으로 간주합니다. 변경에 동의하지 않는 경우 제7조에 따라 탈퇴할 수 있습니다.

### **제9조 (기타)**

1. 본 약관에서 정하지 않은 사항은 앰버서더 계약, 관계 법령 및 상관례에 따릅니다.

2. 전용 페이지 이용과 관련하여 분쟁이 발생한 경우 회사와 가입자는 원만한 해결을 위해 성실히 협의하며, 소송이 제기되는 경우 법령에 정한 절차에 따른 법원을 관할 법원으로 합니다.

**부칙**

본 약관은 2026년 8월 7일부터 시행합니다.
`;

export default function AmbassadorTerms() {
  return (
    <FullPageContainer
      hasFooter={false}
      backgroundColor={theme.vars.palette.Background.Level1}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 800,
          height: "100%",
          overflowY: "auto",
          px: 3,
          py: 2,
          color: (t) => t.vars.palette.Content.Medium,
        }}
      >
        <SimpleMdToTypo source={AMBASSADOR_TERMS_MD} />
      </Box>
    </FullPageContainer>
  );
}
